Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-landing-form'), form, formData;

    if ($form.length < 1)
        return;

    form = $form.get(0);

    formData = {
        firstName: "",
        lastName: "",
        email: "",
        message: "",
        phones: "",
        reCaptchaCode: "",
        terms: false,
    };

    // reCAPTCHA
    var captchaId = "landingCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;


    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.error-recaptcha').hide();
            res = true;
        }
        else {
            $captchaContainer.find('.error-recaptcha').show();
        }

        return res;
    };


    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data.success && data.code === "Landing_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();

            $('.js-success', $form).show();

            form.removeRecaptcha();
        } else {
            $('.js-error', $form).show();
            form.resetRecaptcha();
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Landing Page', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    }

    form.submit = function () {

        var val1 = cf.validate();
        var val2 = form.validateRecaptcha();

        if (!val1 || !val2)
            return;

        form.loading(true);

        Vendd.MessageBus.publishAsync(form, new Vendd.Landing.Messages.Submit(
            $form.data("competition"),
            formData.email,
            formData.firstName,
            formData.lastName,
            formData.message,
            false,
            '',
            formData.phones,
            '', '', '', '',
            formData.reCaptchaCode,
            $('input[name="terms"]:checked').length > 0
        ));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="firstname"]', $form).val("");
        $('input[name="lastname"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="phones"]', $form).val("");
        $('input[name="message"]', $form).val("");

        cf.reset();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (LhApp.Context.IsConsentsEnabled) {
            form.checkConsents();
        } else {
            form.submit();
        }
    });

    $form.on('click', '.js-reset-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.reset();
    });

    $form.on('keyup', 'input[name], textarea[name]', function (e) {
        if (e.keyCode === 13) {

            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            form.submit();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        cf.validate(fieldName);
    });

    $(".view-terms").fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        maxWidth: 940,
        helpers: {
            overlay: {
                locked: true
            }
        }
    });

    //init validation options
    var validationOptions = {
        LandingForm: {
            checkboxRequired: 'LandingForm-required'
        }
    };

    $('.js-required', $form).each(function (e, el) {
        var inputName = $('input', el).attr('name'), tempOption = {};
        validationOptions[inputName] = {
            required: inputName + '-required'
        };
        if ($(this).hasClass('js-invalid-email')) {
            tempOption[inputName] = {
                isEmail: inputName + '-invalid'
            };
            $.extend(true, validationOptions, tempOption);
        }
    });

    //add consent validations
    $.each($('div.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = {
            checkboxRequired: consentType + '-required'
        };
    });

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');


    Vendd.MessageBus.subscribe(Vendd.Landing.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Landing.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submit);
});

